import type { FC, ReactElement } from 'react';
import { memo } from 'react';
import './index.scss';

interface PaginationProps {
  dots: number[];
  currentSlide: number;
  count?: number;
  dotDefaultSize?: number;
  marginDot?: number;
  minSizeDot?: number;
  isWhite?: boolean;
}

const Pagination: FC<PaginationProps> = ({
  dots = [],
  currentSlide = 0,
  count = 7,
  dotDefaultSize = 14,
  marginDot = 2,
  minSizeDot = 6,
  isWhite = false
}) => {
  const renderList: ReactElement[] = [];
  const position = currentSlide;

  for (let i = 0; i < dots.length; i++) {
    let sizeDot = dotDefaultSize;

    const coef = Math.abs(i - position);

    if (coef > 0) {
      sizeDot -= coef * 2;
    }

    if (sizeDot < minSizeDot) {
      sizeDot = minSizeDot;
    }

    renderList.push(
      <div
        key={`dot-${i}`}
        style={{
          display: 'flex',
          height: `${dotDefaultSize}px`,
          width: `${dotDefaultSize}px`,
          justifyContent: 'center',
          alignItems: 'center',
          margin: `${marginDot}px`
        }}
      >
        <div
          className='dot'
          style={{
            minHeight: `${sizeDot}px`,
            minWidth: `${sizeDot}px`,
            backgroundColor: isWhite
              ? position === i
                ? '#ffffff'
                : '#CCCAC4'
              : position === i
              ? '#92022D'
              : '#D791A0'
          }}
        />
      </div>
    );
  }

  const fullDotSize = Number(dotDefaultSize) + Number(marginDot) * 2;

  let transform = currentSlide * fullDotSize;
  const minTransform = ((count - 1) / 2) * fullDotSize;
  const blockSize = fullDotSize * count;
  const maxTransform = (dots.length - count) * fullDotSize;

  if (transform < minTransform) {
    transform = 0;
  } else {
    transform -= minTransform;
  }

  if (transform > maxTransform) {
    transform = maxTransform;
  }
  return (
    <div className='pagination'>
      <div
        className='pagination__wrapper'
        style={{ maxWidth: `${blockSize}px` }}
      >
        <div
          className='pagination-animation'
          style={{ transform: `translateX(-${transform}px)` }}
        >
          {renderList}
        </div>
      </div>
    </div>
  );
};

export default memo(Pagination);
